import { useState } from "react";

import { axiosInstance } from "@refinedev/simple-rest";

import type { Interaction } from "../types/interactions";
import {
  buildComparePrompt,
  buildDescribePrompt,
} from "../utils/insightPrompts";
import type { EntityRecommendations } from "./useSandboxPersonas";

const CHAT_PATH = "/gemini/generate";

export function usePersonaInsights(apiUrl: string) {
  const [description, setDescription] = useState<string | null>(null);
  const [comparison, setComparison] = useState<string | null>(null);
  const [isLoadingDescription, setIsLoadingDescription] = useState(false);
  const [isLoadingComparison, setIsLoadingComparison] = useState(false);

  async function describePersona(interactions: Interaction[]): Promise<void> {
    setIsLoadingDescription(true);
    try {
      const prompt = buildDescribePrompt(interactions);
      const response = await axiosInstance.post(
        `${apiUrl}${CHAT_PATH}`,
        {
          prompt,
        },
        {
          params: {
            "api-version": "1.0",
          },
        },
      );
      setDescription(response.data?.output ?? null);
    } finally {
      setIsLoadingDescription(false);
    }
  }

  async function compareWithResults(
    recommendations: EntityRecommendations,
  ): Promise<void> {
    if (!description) return;
    setIsLoadingComparison(true);
    try {
      const prompt = buildComparePrompt(description, recommendations);
      const response = await axiosInstance.post(
        `${apiUrl}${CHAT_PATH}`,
        {
          prompt,
        },
        {
          params: {
            "api-version": "1.0",
          },
        },
      );
      setComparison(response.data?.output ?? null);
    } finally {
      setIsLoadingComparison(false);
    }
  }

  function reset(): void {
    setDescription(null);
    setComparison(null);
  }

  return {
    description,
    comparison,
    isLoadingDescription,
    isLoadingComparison,
    describePersona,
    compareWithResults,
    reset,
  };
}
